import flatpickr from "flatpickr"
import { Japanese } from "flatpickr/dist/l10n/ja.js"
$(function(){
	if ($('.flatpickr').length > 0){
		//カレンダー入力
		// var myElem = document.getElementById('flatpickr');
		var myElem = $('.flatpickr');
		flatpickr(myElem, {
			"locale": Japanese, // このインスタンスのみの言語指定
			disableMobile: "true"
		});
		// 必須にする。inputにrequiredを設定しないと実行されない
		$('.flatpickr').on('focus', ({ currentTarget }) => $(currentTarget).blur())
		$(".flatpickr").prop('readonly', false)
	};
	if ($('[name="expire_date"]').length > 0 || $('.min-date').length > 0){
		//カレンダー入力
		// var myElem = document.getElementById('flatpickr');
		var myElem = $('.flatpickr');
		flatpickr(myElem, {
			"locale": Japanese, // このインスタンスのみの言語指定
			disableMobile: "true",
			minDate: "today", // 当日以前を選択不可
			// dateFormat: 'Y年n月j日' // フォーマットの変更
		});
	};
	if ($('[name="preferred_date"]').length > 0 || $('.min-date').length > 0){
		//カレンダー入力
		// var myElem = document.getElementById('flatpickr');
		var myElem = $('.flatpickr');
		let today = new Date();// 今日の日付を取得
		flatpickr(myElem, {
			"locale": Japanese, // このインスタンスのみの言語指定
			disableMobile: "true",
			minDate : today.setDate(today.getDate() + 2), // 今日含め2日を選択不可
			// dateFormat: 'Y年n月j日' // フォーマットの変更
		});
	};
});